<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-user-dialog-form">
    <mat-form-field>
      <mat-label>User Name</mat-label>
      <input matInput
             name="data.userName"
             [(ngModel)]="data.userName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input matInput
             name="data.firstName"
             [(ngModel)]="data.firstName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input matInput
             name="data.lastName"
             [(ngModel)]="data.lastName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input matInput
             name="data.title"
             [(ngModel)]="data.title" />
    </mat-form-field><br />
    <ng-container>
      <mat-checkbox name="data.termsAgreement" [(ngModel)]="data.termsAgreement">Terms Agreement</mat-checkbox>
    </ng-container><br />
    <ng-container>
      <mat-checkbox name="data.active" [(ngModel)]="data.active">Is Active</mat-checkbox>
    </ng-container><br />
    <ng-container>
      <mat-checkbox name="data.emailConfirmed" [(ngModel)]="data.emailConfirmed">Email Confirmed</mat-checkbox>
    </ng-container><br />
    <mat-form-field>
      <mat-label>Company</mat-label>
      <input matInput
             name="data.company"
             [(ngModel)]="data.company" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Role</mat-label>
      <mat-select name="currentRole" [(ngModel)]="data.currentRole">
        <mat-option [value]="0">No Role</mat-option>
        <mat-option [value]="4">Consulting User</mat-option>
        <mat-option [value]="3">Report User</mat-option>
        <mat-option [value]="2">Dashboard User</mat-option>
        <mat-option [value]="1">Designer User</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container>
      <mat-checkbox name="data.invoiceManager" [(ngModel)]="data.invoiceManager">Invoice Manager</mat-checkbox>
    </ng-container><br />
    <ng-container>
      <mat-checkbox name="data.userManager" [(ngModel)]="data.userManager">User Manager</mat-checkbox>
    </ng-container><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save User
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
